/**
 * Strip unrendered template variables from user-facing text.
 *
 * Some backend copy (e.g. the spoken live-transfer reason) is a template with
 * `{{placeholder}}` tokens that occasionally reach the UI unfilled — showing a
 * raw `{{reason_say}}` to the agent. Remove those tokens and tidy the leftover
 * whitespace so the text reads cleanly; returns '' when nothing meaningful is
 * left (so callers can hide the field entirely).
 */
export const stripTemplateVariables = (text: string | null | undefined): string => {
  if (!text) return '';
  return text
    // {{ token }} / {{token}} (handlebars/mustache-style)
    .replace(/\{\{[^{}]*\}\}/g, '')
    // collapse the whitespace the removed tokens leave behind
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/ ?\n ?/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};
